import React, { ReactElement, useEffect, useRef } from "react";

export type Props = {
  readonly src?: string;
  readonly onEnded?: () => void;
};

const MaybeAudio = ({ src, onEnded }: Props): ReactElement | null => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (!audioRef?.current || !src) return;

    void (async () => {
      // Check whether audio is allowed to play on page load
      try {
        await audioRef?.current?.play();
      } catch {
        onEnded && onEnded();
      }
    })();
  }, [onEnded, src]);

  // Call onEnded to continue to next state if there is no audio
  useEffect(() => {
    if (!src && onEnded) onEnded();
  }, [src, onEnded]);

  if (!src) return null;

  return <audio ref={audioRef} src={src} onEnded={onEnded} />;
};

export default React.memo(MaybeAudio);
